import { render, staticRenderFns } from "./deliveryNotes.vue?vue&type=template&id=bbaae928&"
import script from "./deliveryNotes.vue?vue&type=script&lang=js&"
export * from "./deliveryNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports